export default __webpack_public_path__ + "static/media/pen_icon.30a0c1ca.svg";